import {
    Component,
    OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'admin',
    styleUrls: ['./admin.component.scss'],
    templateUrl: './admin.component.pug'
})
export class AdminComponent implements OnInit {

    public localState: any;
    constructor(
        public route: ActivatedRoute,
        public translate: TranslateService
    ) {
    }

    public ngOnInit() {

        console.log('hello `Custom` component');

    }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts